import { ShipType } from '../types';

export function translateShipType(type: ShipType) {
  switch (type.name) {
    case 'MANEUVER_SUPPORT':
      return 'Apoio à Manobra';
    case 'DIVING_SUPPORT':
      return 'Apoio a Mergulho';
    case 'FERRY':
      return 'Balsa';
    case 'LIGHTER':
      return 'Barcaça';
    case 'BARGE':
      return 'Batelão';
    case 'BOAT':
      return 'Bote';
    case 'FLOATING_CRANE':
      return 'Cábrea';
    case 'CANOE':
      return 'Canoa';
    case 'GENERAL_CARGO':
      return 'Carga Geral';
    case 'REFRIGERATED_CARGO':
      return 'Carga Refrigerada';
    case 'LIVE_CARGO':
      return 'Carga Viva';
    case 'CATAMARAN':
      return 'Catamarã';
    case 'FLAT_BOAT':
      return 'Chata';
    case 'FLOATING_DAM':
      return 'Dique Flutuante';
    case 'DREDGE':
      return 'Draga';
    case 'SCHOONER':
      return 'Escuna';
    case 'FERRY_BOAT':
      return 'Ferry Boat';
    case 'LIQUEFIED_GASES':
      return 'Gases Liquefeitos';
    case 'BULK_CARRIER':
      return 'Graneleiro';
    case 'SPEEDBOAT':
      return 'Lancha';
    case 'SISTER_SHIP':
      return 'Navio Cisterna';
    case 'DRILLSHIP':
      return 'Navio Sonda';
    case 'OTHER_VESSELS':
      return 'Outras Embarcações';
    case 'PASSENGER':
      return 'Passageiro';
    case 'PASSENGER_GENERAL_CARGO':
      return 'Passageiro / Carga Geral';
    case 'PASSENGER_ROLL_ON_OFF':
      return 'Passageiros / Roll-On Roll-Off';
    case 'FISHERMAN':
      return 'Pesqueiro';
    case 'RESEARCH':
      return 'Pesquisa';
    case 'TANKER':
      return 'Petroleiro';
    case 'PLATFORM':
      return 'Plataforma';
    case 'JACK_UP_PLATFORM':
      return 'Plataforma Auto-elevável';
    case 'SEMI_SUBMERSIBLE_PLATFORM':
      return 'Plataforma Semi-Submersível';
    case 'CONTAINER_DOOR':
      return 'Porta Contentor';
    case 'ICE_BREAKER':
      return 'Quebra-gelo';
    case 'CHEMICAL':
      return 'Químico';
    case 'TUGBOAT':
      return 'Rebocador Empurrador';
    case 'PORT_TUGBOAT':
      return 'Rebocador Portuário';
    case 'ROLL_ON_OFF':
      return 'Roll-On Roll-Off';
    case 'SAILING_BOAT':
      return 'Saveiro';
    case 'SUBMERSIBLE':
      return 'Submersível';
    case 'SUPPLY':
      return 'Supply';
    case 'ASPHALT_CARRIER':
      return 'Tanque de Asfalto';
    case 'TRAWLER':
      return 'Traineira';
    case 'FPSO':
      return 'Unidade de produção e armazenamento de petróleo (FPSO)';
    case 'SAILING_SHIP':
      return 'Veleiro';
    case 'MILITARY_SHIP':
      return 'Navio Militar';
    default:
      return '';
  }
}
